import styled from "styled-components";

export const ContactTitle = styled.h4`
  color: #951211;
  font-weight: 500;
  margin: 0px;
  font-family: "Roboto", sans-serif;
`;

export const ContactTitleTwo = styled.h4`
  color: #951211;
  font-weight: 700;
  margin: 0px;
  font-family: "Roboto", sans-serif;
`;

export const ContactTitleGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 30px;
`;
